<template>
  <div>
    <HomeView />
  </div>
</template>

<script>
import HomeView from '../modules/home/views/Home'

export default {
  components: { HomeView },

  data() {
    return {
      baseTitle: 'Devlusaja | Perfil',
      baseDescription:
        'Explora mi perfil y proyectos relacionados con Inteligencia Artificial, tecnología y desarrollo web en Devlusaja.com.',
    }
  },

  watch: {
    $route(to) {
      this.updateMeta()
      console.log('Ruta actual:', to.path)
    },
  },

  mounted() {
    this.updateMeta()
  },

  methods: {
    updateMeta() {
      document.title = this.baseTitle
      this.setMetaTag('description', this.baseDescription)
      this.setMetaTag('og:title', this.baseTitle)
      this.setMetaTag('og:description', this.baseDescription)
      this.setMetaTag('og:image', 'https://devlusaja.com/assets/img/preview-home.png')
      this.setMetaTag('og:url', window.location.href)
    },

    setMetaTag(name, content) {
      let tag =
        document.querySelector(`meta[name="${name}"]`) ||
        document.querySelector(`meta[property="${name}"]`)
      if (tag) {
        tag.setAttribute('content', content)
      } else {
        tag = document.createElement('meta')
        if (name.startsWith('og:')) tag.setAttribute('property', name)
        else tag.setAttribute('name', name)
        tag.setAttribute('content', content)
        document.head.appendChild(tag)
      }
    },
  },
}
</script>
